new Swiper('#images', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 5,
    speed: 300,
    grabCursor: true,
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    navigation: {
        nextEl: '.images_container .next',
        prevEl: '.images_container .prev'
    },
})